module.exports = __webpack_public_path__ + "img/en-slider_text_d1.7fd0ea56.png";